import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class AccountClassService extends DatabaseGwService {
  URL_PATH: string = "/acc-classes";
  
}
